/** 
 * preload.js [AA 1/24] 
 * --------------------
 * Pairs with 'unload.js'
 * Defers scripts, videos, and iframes until all document body content has loaded
 * Use the data attribute [data-load-priority] to skip deferring
 * @example
 * <script src="example.js" data-load-priority></script>
 * */

; (function preloadJS() {
  function lazyIframe(e) {
    e.setAttribute("loading", "lazy");
    e.src && e.setAttribute("data-src", e.src);
    e.removeAttribute("src");
  }

  function lazyVideo(e) {
    if (e.src) {
      (e.src && e.setAttribute("data-src", e.src)), e.removeAttribute("src");
    } else if (e.innerHTML) {
      e.dataset.html = e.innerHTML;
      e.innerHTML = '';
    }
  }

  function lazyJS(e) {
    if (e.innerHTML.includes("asyncLoad")) {
      // AsyncLoad
      e.innerHTML = e.innerHTML.replace("if(window.attachEvent)", "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)").replaceAll(", asyncLoad", ", function(){}")
    } else if ((e.innerHTML.includes("PreviewBarInjector") || e.innerHTML.includes("adminBarInjector"))) {
      // previewBar
      e.innerHTML = e.innerHTML.replace("DOMContentLoaded", "loadBarInjector")
    } else if (e.src) {
      e.setAttribute("data-src", e.src)
      e.removeAttribute("src")
      e.dataset.type = e.type
      e.type = "text/lazyload"
    } else {
      e.dataset.type = e.type
      e.type = "text/lazyload"
    }
  }

  function hasPriority(e) {
    return e.hasAttribute('data-load-priority');
  }

  ; (function init() {
    window.uLTS = new MutationObserver(mutationRec => {
      mutationRec.forEach(({ addedNodes }) => {
        addedNodes.forEach(node => {
          1 === node.nodeType && "IFRAME" === node.tagName && !hasPriority(node) && lazyIframe(node),
            1 === node.nodeType && "VIDEO" === node.tagName && !hasPriority(node) && lazyVideo(node),
            1 === node.nodeType && "SCRIPT" === node.tagName && !hasPriority(node) && lazyJS(node)
        })
      })
    });

    window.uLTS.observe(document.documentElement, { childList: !0, subtree: !0 });
  })();
})()